package com.karawek.core.auth.screen

import com.karawek.core.auth.model.AuthenticatedUser
import com.karawek.core.auth.model.OtpChannel
import androidx.compose.runtime.Immutable
import com.karawek.core.circuit.Parcelize
import com.slack.circuit.runtime.CircuitUiState
import com.slack.circuit.runtime.screen.Screen
import com.slack.circuit.runtime.screen.PopResult

@Parcelize
data class OtpVerificationScreen(
    val channel: OtpChannel,
    val destination: String,
    val loginOrCreate: Boolean = true,
) : Screen

@Parcelize
data class OtpVerificationResult(
    val status: Status,
    val userInfo: AuthenticatedUser? = null,
) : PopResult {
    enum class Status { Verified, Cancelled }
}

@Immutable
data class OtpVerificationState(
    val channel: OtpChannel,
    val destination: String,
    val otpCode: String = "",
    val isLoading: Boolean = false,
    val errorMessage: String? = null,
    // Rate-limiting state
    val canResend: Boolean = true,
    val isLockedOut: Boolean = false,
    val resendAttempts: Int = 0,
    val resendCountdownSeconds: Int = 0,
    val eventSink: (OtpVerificationEvent) -> Unit = {},
) : CircuitUiState

sealed interface OtpVerificationEvent {
    data object OnAppear : OtpVerificationEvent
    data object Back : OtpVerificationEvent
    data object Resend : OtpVerificationEvent

    data class UpdateOtpCode(val value: String) : OtpVerificationEvent
    data object Verify : OtpVerificationEvent
}
